import { DocData } from './doc-data';

export const testing: DocData = {
  titleKey: 'docs.testing.title',
  descriptionKey: 'docs.testing.description',
  route: 'testing',
  iconSvg: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round"
         class="lucide lucide-activity h-10 w-10 text-info">
      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"></path>
    </svg>
  `,
  tooltipShortKey: 'docs.testing.tooltipShort',
  tooltipLinkKey: 'docs.testing.tooltipLink'
};
